import { Skeleton } from '@/components/ui/Skeleton.tsx';
import TwoInputsRow from '@/components/form/ui/TwoInputsRow.tsx';

const DiscountFormSkeleton = () => {
  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-[34px] w-full" />
      </div>

      <div className="space-y-1.5">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-[34px] w-48" />
      </div>

      <TwoInputsRow ratio="2/1">
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-[34px] w-full" />
        </div>
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-[34px] w-full" />
        </div>
      </TwoInputsRow>

      <div className="space-y-1.5">
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-20" />
        </div>
        <Skeleton className="h-[34px] w-full" />
      </div>

      <Skeleton className="h-5 w-24" />

      <Skeleton className="h-px w-full" />

      <TwoInputsRow>
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-[34px] w-full" />
        </div>
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-[34px] w-full" />
        </div>
      </TwoInputsRow>

      <TwoInputsRow>
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-[34px] w-full" />
        </div>
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-36" />
          <Skeleton className="h-[34px] w-full" />
        </div>
      </TwoInputsRow>

      <div className="space-y-1.5">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-[34px] w-full" />
      </div>

      <Skeleton className="h-5 w-48" />

      <div className="space-y-1.5">
        <Skeleton className="h-4 w-52" />
        <Skeleton className="h-[34px] w-full" />
      </div>
    </div>
  );
};

export default DiscountFormSkeleton;
